module.exports = {"TXTWCL_Continue":{"id":"TXTWCL_Continue","defaultMessage":"Weiter","track":"Continue"}}